import { useEffect, useState } from "react";
import {
    Button,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row
} from "reactstrap";

import { CoordinatorDto, GroupFormData } from "../types/Group";

interface Props {
    initialValues: GroupFormData;
    coordinators: CoordinatorDto[];
    onSubmit: (data: GroupFormData) => Promise<void>;
    isEdit?: boolean;
}

const GroupForm = ({
    initialValues,
    coordinators,
    onSubmit,
    isEdit = false
}: Props) => {

    const [formData, setFormData] =
        useState<GroupFormData>(initialValues);

    useEffect(() => {
        setFormData(initialValues);
    }, [initialValues]);

   const handleChange = (
    e: React.ChangeEvent<
        HTMLInputElement |
        HTMLTextAreaElement |
        HTMLSelectElement
    >
) => {

    const target = e.target;
    const { name, value } = target;

    if (target instanceof HTMLInputElement && target.type === "checkbox") {

        const checked = target.checked;

        if (name === "isPaymentRequired") {

            setFormData(prev => ({
                ...prev,
                isPaymentRequired: checked,
                groupPayment: checked ? prev.groupPayment : null
            }));

            return;
        }

        setFormData(prev => ({
            ...prev,
            [name]: checked
        }));

        return;
    }

    if (name === "region") {

        setFormData(prev => ({
            ...prev,
            region: value,
            state:
                value.toLowerCase() === "online"
                    ? null
                    : prev.state,
            district:
                value.toLowerCase() === "online"
                    ? null
                    : prev.district
        }));

        return;
    }

    setFormData(prev => ({
        ...prev,
        [name]:
            target instanceof HTMLInputElement &&
            target.type === "number"
                ? value === ""
                    ? null
                    : Number(value)
                : value
    }));
};

    const handleSubmit = async (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        await onSubmit(formData);

    };

    return (

        <Form onSubmit={handleSubmit} style={{fontWeight:"bold"}}>

            <Row >

                <Col md="6" >
                    <FormGroup >
                        <Label>Group Name</Label>
                        <Input
                            name="groupName"
                            value={formData.groupName}
                            onChange={handleChange}
                            required
                        />
                    </FormGroup>
                </Col>

                <Col md="6">
                    <FormGroup>
                        <Label>Type</Label>
                        <Input
                            type="select"
                            name="type"
                            value={formData.type}
                            onChange={handleChange}
                        >
                            <option value="">Select</option>
                            <option value="Course">Course</option>
                            <option value="Product">Product</option>
                        </Input>
                    </FormGroup>
                </Col>

            </Row>

            <Row >

                <Col md="6">
                    <FormGroup>
                        <Label>Category</Label>
                        <Input
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                        />
                    </FormGroup>
                </Col>

                <Col md="6">
                    <FormGroup>
                        <Label>Amount</Label>
                        <Input
                            type="number"
                            name="amount"
                            value={formData.amount}
                            onChange={handleChange}
                        />
                    </FormGroup>
                </Col>

            </Row>
            <Row >
                 <Col md="6">
                    <FormGroup>
                        <Label>Language</Label>
                        <Input
                            name="language"
                            value={formData.language}
                            onChange={handleChange}
                        />
                    </FormGroup>
                </Col>

                <Col md="6">
                    <FormGroup>
                        <Label>Region</Label>
                        <Input
    type="select"
    name="region"
    value={formData.region}
    onChange={handleChange}
>
    <option value="">Select Region</option>
    <option value="Online">Online</option>
    <option value="Tamil Nadu">Tamil Nadu</option>
    <option value="Karnataka">Karnataka</option>
    <option value="Kerala">Kerala</option>
    <option value="Andhra Pradesh">Andhra Pradesh</option>
</Input>
                    </FormGroup>
                </Col>
{
    formData.region !== "Online" && (

        <Row >

            <Col md="6">

                <FormGroup>

                    <Label>State</Label>

                    <Input
                        name="state"
                        value={formData.state ?? ""}
                        onChange={handleChange}
                        required
                    />

                </FormGroup>

            </Col>

            <Col md="6">

                <FormGroup style={{marginLeft:"15px", width:"370px"}}>

                    <Label>District</Label>

                    <Input
                        name="district"
                        value={formData.district ?? ""}
                        onChange={handleChange}
                        required
                    />

                </FormGroup>

            </Col>

        </Row>

    )
}
               

            </Row>

            <FormGroup >
                <Label>Short Description</Label>
                <Input
                    type="textarea"
                    rows={2}
                    name="shortDescription"
                    value={formData.shortDescription ?? ""}
                    onChange={handleChange}
                />
            </FormGroup>

            <FormGroup>
                <Label>Long Description</Label>
                <Input
                    type="textarea"
                    rows={5}
                    name="longDescription"
                    value={formData.longDescription ?? ""}
                    onChange={handleChange}
                />
            </FormGroup>

            <FormGroup>
                <Label>Syllabus</Label>
                <Input
                    type="textarea"
                    rows={4}
                    name="syllabus"
                    value={formData.syllabus ?? ""}
                    onChange={handleChange}
                />
            </FormGroup>


            <FormGroup>
                <Label>Coordinators</Label>

                <Input
                    type="select"
                    multiple
                    value={formData.coordinatorIds}
                    onChange={(e) => {

                        const select = e.currentTarget as unknown as HTMLSelectElement;

                        const ids = Array.from(
                            select.selectedOptions
                        ).map((option) => option.value);

                        setFormData(prev => ({
                            ...prev,
                            coordinatorIds: ids
                        }));

                    }}
                >
                    {coordinators.map((c) => (
                        <option
                            key={c.userID}
                            value={c.userID}
                        >
                            {c.name} ({c.email})
                        </option>
                    ))}
                </Input>

                <small className="text-muted">
                    Hold Ctrl (Windows) or Cmd (Mac) to select multiple coordinators.
                </small>
            </FormGroup>



            <FormGroup check className="mb-3">
                <Input
                    type="checkbox"
                    name="isPaymentRequired"
                    checked={formData.isPaymentRequired}
                    onChange={handleChange}
                />
                <Label check>
                    Payment Required
                </Label>
            </FormGroup>
            <FormGroup className="mt-3">

                <Label>Group Payment</Label>

                <Input
                    type="number"
                    name="groupPayment"
                    value={formData.groupPayment ?? ""}
                    onChange={handleChange}
                    disabled={!formData.isPaymentRequired}
                    required={formData.isPaymentRequired}
                    min={1}
                    placeholder="Enter group payment"
                />

                {!formData.isPaymentRequired && (
                    <small className="text-muted">
                        Enable "Payment Required" to enter the group payment.
                    </small>
                )}

            </FormGroup>
            {isEdit && (

                <FormGroup check className="mb-3">
                    <Input
                        type="checkbox"
                        name="isActive"
                        checked={formData.isActive}
                        onChange={handleChange}
                    />
                    <Label check>
                        Active
                    </Label>
                </FormGroup>

            )}

            <FormGroup>
                <Label>Notification Banner</Label>
                <Input
                    name="notificationBanner"
                    value={formData.notificationBanner ?? ""}
                    onChange={handleChange}
                />
            </FormGroup>

            <Button color="primary" type="submit">
                {isEdit ? "Update Group" : "Create Group"}
            </Button>

        </Form>

    );
};

export default GroupForm;